<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="用户姓名">              
              <a-input placeholder="请输入关联事件的用户姓名" v-model="queryParam.realName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="发生时间">                  
              <a-range-picker @change="queryParamDateRangeChange" />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="核查状态">                  
              <a-select v-model="queryParam.status" allowClear>
                    <a-select-option :value="0">
                      未核查
                    </a-select-option>
                    <a-select-option :value="1">
                      通过
                    </a-select-option>
                    <a-select-option :value="2">
                      未通过
                    </a-select-option>
                  </a-select>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>                  
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <template v-if="record.status === 0">
            <a-divider type="vertical" />
            <a @click="handleCheck(record)">审核</a>
          </template>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">              
               <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <event-modal ref="modalForm" @ok="modalFormOk" :projectId="projectId"></event-modal>
    <a-modal
      :visible="checkedVisible"
      title="事件审核"
      :width="'50%'"
        @ok="handleCheckedSubmit"
        @cancel="checkedVisible = false"
        :okText="'提交'"
        :cancelText="'取消'"
      >
        <a-form>
          <a-form-item label="是否审核通过" :labelCol="{ span: 5 }" :wrapperCol="{ span: 15 }">
            <a-radio-group v-model="formCheck.status">
              <a-radio :value="1">通过</a-radio>
              <a-radio :value="2">未通过</a-radio>
            </a-radio-group>
          </a-form-item>          
        </a-form>
      </a-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import EventModal from './modules/EventModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import { postAction } from '@/api/manage'

  export default {
    name: "EventLists",
    mixins:[JeecgListMixin],
    components: {
      EventModal
    },
    data () {
      return {        
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        // 表头
        columns: [
          {
            title: '用户姓名',
            align:"center",
            width:120,
            ellipsis: true,
            dataIndex: 'realName',
          },
          {
            title: '发生时间',
            width:120,
            ellipsis: true,
            align:"center",
            dataIndex: 'eventTime'
          },
          {
            title: '事件类型',
            align:"center",
            ellipsis: true,
            width:100,
            dataIndex: 'type',
            customRender: function (text) {
              if (text === 1) {
                return '投诉'
              } else if (text === 0) {
                return '其他'
              } else {
                return text
              }
            }
          },
          {
            title: '核查状态',
            align:"center",
            width:120,
            dataIndex: 'status',
            customRender:(value,row,index)=>{
              if(value !==0 && value){
                return  value===1?'通过':'未通过'
              }else{
                return '未核查'
              }
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width:100,
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/project/projectEvent/list",
          delete: "/project/projectEvent/delete",
        },
        checkedVisible:false,
        formCheck:{
          status:1,
          id:"",
        }
      }
    },
    computed: {
      
    },
    mounted(){
      this.queryParam.projectId = this.projectId;
    },
    methods: {
      loadDataBefore(){
        this.queryParam.projectId = this.projectId;
      },
      queryParamDateRangeChange(date, dateString){
        this.queryParam.eventTime_begin = dateString[0]
        this.queryParam.eventTime_end = dateString[1]
      },
      handleResEdit(record){
        this.$refs['modalMessageForm'].edit(record)
      },
      handleCheck(record) {
        this.checkedVisible = true
        this.formCheck.id = record.id
      },
      handleCheckedSubmit() { 
        postAction('/project/projectEvent/checked',this.formCheck).then(res=>{
              if(res.success){
                this.loadData()
                this.checkedVisible = false                
                this.$message.success('审核成功！')
              }else{
                this.$message.warning(res.message)
              }
            })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>